import { Link } from 'react-router-dom';

const footerLinks = {
  services: {
    title: '服务项目',
    links: [
      { label: '体育培训', to: '/category/training' },
      { label: '赛事组织', to: '/category/events' },
      { label: '运动健身', to: '/category/fitness' },
      { label: '场馆预约', to: '/category/venues' },
      { label: '青少年训练', to: '/category/youth' },
      { label: '会员服务', to: '/category/membership' },
    ],
  },
  company: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', to: '/about' },
      { label: '联系我们', to: '/about#contact' },
      { label: '加入我们', to: '/about' },
      { label: '合作伙伴', to: '/about#partners' },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '常见问题', to: '/#faq' },
      { label: '会员协议', to: '/about' },
      { label: '隐私政策', to: '/about' },
      { label: '退款政策', to: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-basketball-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold tracking-wide text-background-50">云开体育</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              专业体育服务平台，致力于让更多人享受运动乐趣，助力全民健身事业蓬勃发展。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{section.title}</h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-foreground-400 hover:text-accent-400 text-sm transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 云开体育 YunKai Sports. 保留所有权利。
          </p>
          <p className="text-foreground-500 text-xs">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-accent-400 transition-colors">京ICP备2026080001号</a>
          </p>
        </div>
      </div>
    </footer>
  );
}